import { render, staticRenderFns } from "./ListItemGeofence.vue?vue&type=template&id=52616bb0"
import script from "./ListItemGeofence.vue?vue&type=script&lang=js"
export * from "./ListItemGeofence.vue?vue&type=script&lang=js"
import style0 from "./ListItemGeofence.vue?vue&type=style&index=0&id=52616bb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports